
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useDebounce.html",
      function () {
        return require("private-next-pages/Hooks/useDebounce.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useDebounce.html"])
      });
    }
  